<template>
  <vs-popup
    id="attendances-cloud-costs-report-popup"
    title="Relatório de Atendimentos e Custos Cloud"
    :active.sync="isActive"
    @close="close()"
  >
    <div class="report-form">
      <div class="form-group">
        <label>Data Inicial</label>
        <flat-pickr
          :config="flatpickr"
          v-model="startAt"
          placeholder="Escolha um dia"
          v-validate="'required'"
        />
      </div>

      <div class="form-group">
        <label>Data Final</label>
        <flat-pickr
          :config="finishAtConfig(flatpickr)"
          v-model="finishAt"
          placeholder="Escolha um dia"
          v-validate="'required'"
          :disabled="startAt === ''"
        />
      </div>

      <div class="form-actions">
        <vs-button
          type="filled"
          @click="getAttendances()"
          :disabled="disableDownload"
        >
          Gerar
        </vs-button>
      </div>
    </div>

    <ul>
      <li v-for="(url, index) in attendancesData" :key="index">
        <a class="ml-2" :href="url" target="_blank">
          Clique aqui para baixar
        </a>
      </li>
    </ul>
  </vs-popup>
</template>

<script>
import { mapGetters } from 'vuex';
import 'flatpickr/dist/flatpickr.css';
import flatPickr from 'vue-flatpickr-component';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';

export default {
  name: 'AttendancesAndCloudCostsReport',
  components: { flatPickr },
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    websiteId: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters(['token']),
    disableDownload() {
      return !this.startAt || !this.finishAt || this.startAt === '' || this.finishAt === '';
    }
  },
  data() {
    return {
      startAt: '',
      finishAt: '',
      attendancesData: [],
      flatpickr: {
        enableTime: false,
        noCalendar: false,
        dateFormat: 'd/m/Y',
        locale: Portuguese
      }
    };
  },
  methods: {
    close() {
      this.startAt = '';
      this.finishAt = '';
      this.attendancesData = [];
      this.$emit('isActiveFalse');
    },
    finishAtConfig(config) {
      return {
        ...config,
        minDate: this.startAt
      };
    },
    parseDate(dateString, toBrazilian = false) {
      if (!dateString) return dateString;
      const parts = dateString.split(toBrazilian ? '-' : '/');
      return toBrazilian ? `${parts[2]}/${parts[1]}/${parts[0]}` : `${parts[2]}-${parts[1]}-${parts[0]}`;
    },
    getAttendances() {
      this.$vs.loading();
      this.$store.dispatch('getAttendances', {
        startAt: this.parseDate(this.startAt),
        finishAt: this.parseDate(this.finishAt),
        websiteId: this.websiteId,
        estimation: true,
        attendance: true,
        token: this.token
      }).then(response => {
        this.attendancesData = response.data;
        if (
          (Array.isArray(this.attendancesData) && this.attendancesData.length === 0) ||
          (
            typeof this.attendancesData === 'object' &&
            this.attendancesData !== null &&
            Object.keys(this.attendancesData).length === 0
          )
        ) {
          this.$vs.notify({
            color: 'danger',
            title: 'Não há dados para gerar o relatório.'
          });
        }
      }).catch(exception => {
        console.error(exception);
        this.$vs.notify({
          color: 'danger',
          title: 'Erro!',
          text: 'Ocorreu um erro ao realizar a ação! Entre em contato com o time técnico.'
        });
      }).finally(() => {
        this.$vs.loading.close();
      });
    }
  },
  watch: {
    isActive(value) {
      if (!value) {
        this.startAt = '';
        this.finishAt = '';
        this.attendancesData = [];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.report-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

#attendances-cloud-costs-report-popup {
  z-index: 51020 !important;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}
</style>